/**
 * Smooth Scroll for Anchor Links
 * Handles # links to scroll to top and anchor links to scroll to IDs
 */
(function($) {
    'use strict';

    $(document).ready(function() {
        // Handle all anchor links
        $('a[href^="#"]').on('click', function(e) {
            const href = $(this).attr('href');
            
            // If href is just "#", scroll to top
            if (href === '#') {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: 0
                }, 600, 'swing');
                return false;
            }
            
            // Otherwise, find the target element
            const target = $(href);
            
            // If target exists, scroll to it
            if (target.length) {
                e.preventDefault();
                $('html, body').animate({
                    scrollTop: target.offset().top - 100 // 100px offset for fixed headers
                }, 600, 'swing');
                
                // Update URL hash without jumping
                if (history.pushState) {
                    history.pushState(null, null, href);
                }
                
                return false;
            }
        });
    });

})(jQuery);

